'use client'

import type { HTMLChakraProps, RecipeProps, UnstyledProp } from '@chakra-ui/react'
import { createRecipeContext } from '@chakra-ui/react'

const { withContext, PropsProvider } = createRecipeContext({
    key: 'link',
})

export interface ILinkBaseProps extends RecipeProps<'link'>, UnstyledProp {}

export interface ILinkProps extends HTMLChakraProps<'a', ILinkBaseProps> {
    isExternal?: boolean
}

const BaseLink = withContext<HTMLAnchorElement, ILinkProps>('a')

export const Link = ({ isExternal, ...props }: ILinkProps) => {
    return (
        <BaseLink
            {...props}
            {...(isExternal
                ? {
                      target: '_blank',
                      rel: 'noopener noreferrer',
                  }
                : {})}
        />
    )
}

export const LinkPropsProvider = PropsProvider as React.Provider<ILinkProps>
